// @ts-ignore
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.swiper-container', {
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 1500,
    autoplay: {
      delay: 3200,
      disableOnInteraction: false,
    },
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-navigation-next',
      prevEl: '.swiper-navigation-prev',
    },
  })

  // FAQトグル機能
  document.querySelectorAll('.faq__question').forEach((question) => {
    question.addEventListener('click', () => {
      const answer = question.nextElementSibling
      if (answer && answer.classList.contains('faq__answer')) {
        answer.classList.toggle('is-open')
        // @ts-ignore
        answer.style.display = // @ts-ignore
          answer.style.display === 'block' ? 'none' : 'block'
      }
      question.parentElement?.classList.toggle('is-open')
    })
  })

  const cvrBtn = document.getElementById('cvrBtn')
  const hero = document.getElementById('hero')
  const gFooter = document.getElementById('gFooter')

  const observer = new IntersectionObserver(
    (entries, observer) => {
      // 全ての監視対象が画面内にあるかどうかをチェックするフラグ
      let allIntersecting = true

      entries.forEach((entry) => {
        if (!entry.isIntersecting) {
          allIntersecting = false
        }
      })

      // 全ての要素が画面内にあればshowを削除、そうでなければ追加
      if (allIntersecting) {
        cvrBtn?.classList.remove('show')
      } else {
        cvrBtn?.classList.add('show')
      }
    },
    { threshold: 0 },
  )

  // 複数の要素を監視対象に追加
  if (hero) observer.observe(hero)
  if (gFooter) observer.observe(gFooter)

  // ハンバーガーメニュー
  const hamburger = document.getElementById('hamburger')
  const nav = document.getElementById('gNavi')
  const header = document.getElementById('header')
  const body = document.body
  if (hamburger && nav) {
    hamburger.addEventListener('click', () => {
      header?.classList.toggle('is-open')
      body.classList.toggle('is-fixed')
    })
  }

  // #から始まるURLがクリックされた時
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      e.preventDefault()
      const href = anchor.getAttribute('href')
      const target = href
        ? document.getElementById(href.replace('#', ''))
        : null
      if (target) {
        const targetRect = target.getBoundingClientRect()
        const offsetTop = targetRect.top + window.scrollY - 70
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth',
        })
      }
      // ハンバーガーメニューのis-openやis-fixedを削除
      header?.classList.remove('is-open')
      body.classList.remove('is-fixed')
    })
  })
})
